import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

export var form =
{
	model: 'category',

	form_title: 'Catégorie',

	fields:
	{
		name:
		{
			label: 'Libellé'
		},

		parent:
		{
			label: 'Catégorie parente',
			reference:
			{
				model: 'category',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				},
				autocomplete:
				{
					'name':
					{
						type: 'text'
					}
				}
			}
		}
	},

	create_label: 'Créer cette catégorie',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cette catégorie&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['category[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					La nouvelle catégorie <strong> { model.name } </strong> a été créée.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-du-catalogue/categories/' + model.id }>
						Voir la catégorie
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export var list =
{
	model         : 'category',
	title         : 'Liste des catégories',
	link          : '/gestion-du-catalogue/categories',
	creation_link : '/gestion-du-catalogue/nouvelle-categorie',
	creation_label: 'Créer une nouvelle catégorie',
	header_map:
	{
		'Nom': 'name',
		'Catégorie parente': 'parent'
	},
	row_link_base: '/gestion-du-catalogue/categories/',
	searched_prop: 'name',
	sort: function (categories)
	{
		let sorted = [];

		(categories || []).forEach(function (category)
		{
			if (sorted.length === 0) return sorted.push(category);

			let name = category.name, parent = category.parent;

			if (parent)
			{
				parent = sorted.find(sorted => sorted.name === parent);

			// insert after its parent category
				if (parent)
				{
					category.name = '\t' + category.name;

					sorted.splice(sorted.indexOf(parent) + 1, 0, category);
				}
				else
				{
					sorted.push(category);
				}
			}
			else
			{
				let child = sorted.find(sorted => sorted.parent === name);

				if (child)
				{
				// insert before its first child
					sorted.splice(sorted.indexOf(child), 0, category);
				}
				else
				{
					sorted.push(category);
				}
			}
		});

		return sorted;
	}
};

var config = mergeDeep({ }, form);

mergeDeep(config, list);

export default config